import _ from "lodash";
import { Filter, Where } from "../entityTable/Filter";

export class EntityTableHelper {
    public static MergeFilters(filter1?: Filter, filter2?: Filter | null): Filter {
        if (!filter2 && !filter1) {
            return {} as Filter;
        }
        if (!filter1 && filter2) {
            return filter2;
        }
        if (!filter2 && filter1) {
            return filter1;
        }
        const parts = filter1?.parts || [];
        parts.push(...(filter2?.parts || []));
        return { where: this.MergeWheres(filter1?.where, filter2?.where), parts } as Filter;
    }
    public static MergeWheres(where1: Where | undefined, where2: Where | undefined | null): Where {
        if (!where1 && !where2) {
            return {} as Where;
        }
        if (where1 && !where2) {
            return where1;
        }
        if (!where1 && where2) {
            return where2;
        }
        const where = _.cloneDeep(where1) as Where;
        if (Array.isArray(where.AND)) {
            where.AND.unshift(where2 as Where);
        } else {
            where.AND = [where2 as Where];
        }
        return where;
    }
}
